var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 480,
    viewBox: "0 0 640 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_66_570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M912.009 0H0V36.9234H912.009V0Z",
    fill: "#BD3D44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.009 73.8469H0V110.77H912.009V73.8469Z",
    fill: "#BD3D44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.009 147.694H0V184.617H912.009V147.694Z",
    fill: "#BD3D44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.009 221.541H0V258.464H912.009V221.541Z",
    fill: "#BD3D44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.009 295.388H0V332.311H912.009V295.388Z",
    fill: "#BD3D44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.009 369.234H0V406.158H912.009V369.234Z",
    fill: "#BD3D44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.009 443.081H0V480.005H912.009V443.081Z",
    fill: "#BD3D44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.009 36.9234H0V73.8469H912.009V36.9234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.009 110.77H0V147.694H912.009V110.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.009 184.617H0V221.541H912.009V184.617Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.009 258.464H0V295.387H912.009V258.464Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.009 332.311H0V369.234H912.009V332.311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.009 406.158H0V443.081H912.009V406.158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.8 0H0V258.459H364.8V0Z",
    fill: "#192F5D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4003 11.0623L33.7195 21.2779H44.4607L35.7708 27.5914L39.0902 37.807L30.4003 31.4935L21.7104 37.807L25.0298 27.5914L16.3398 21.2779H27.0811L30.4003 11.0623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.2011 11.0623L94.5203 21.2779H105.262L96.5716 27.5914L99.891 37.807L91.2011 31.4935L82.5111 37.807L85.8306 27.5914L77.1406 21.2779H87.8818L91.2011 11.0623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.003 11.0623L155.322 21.2779H166.063L157.373 27.5914L160.693 37.807L152.003 31.4935L143.313 37.807L146.632 27.5914L137.942 21.2779H148.684L152.003 11.0623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.801 11.0623L216.12 21.2779H226.862L218.172 27.5914L221.491 37.807L212.801 31.4935L204.111 37.807L207.431 27.5914L198.741 21.2779H209.482L212.801 11.0623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.603 11.0623L276.922 21.2779H287.663L278.973 27.5914L282.293 37.807L273.603 31.4935L264.913 37.807L268.232 27.5914L259.542 21.2779H270.284L273.603 11.0623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.405 11.0623L337.724 21.2779H348.465L339.775 27.5914L343.095 37.807L334.405 31.4935L325.715 37.807L329.034 27.5914L320.344 21.2779H331.085L334.405 11.0623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.8021 36.9087L64.1214 47.1243H74.8626L66.1727 53.4378L69.4921 63.6534L60.8021 57.3399L52.1122 63.6534L55.4316 53.4378L46.7417 47.1243H57.4829L60.8021 36.9087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.6 36.9087L124.92 47.1243H135.661L126.971 53.4378L130.29 63.6534L121.6 57.3399L112.911 63.6534L116.23 53.4378L107.54 47.1243H118.281L121.6 36.9087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.402 36.9087L185.721 47.1243H196.463L187.773 53.4378L191.092 63.6534L182.402 57.3399L173.712 63.6534L177.032 53.4378L168.342 47.1243H179.083L182.402 36.9087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.204 36.9087L246.523 47.1243H257.264L248.575 53.4378L251.894 63.6534L243.204 57.3399L234.514 63.6534L237.833 53.4378L229.144 47.1243H239.885L243.204 36.9087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.002 36.9087L307.321 47.1243H318.062L309.372 53.4378L312.692 63.6534L304.002 57.3399L295.312 63.6534L298.631 53.4378L289.941 47.1243H300.683L304.002 36.9087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4003 62.7551L33.7195 72.9707H44.4607L35.7708 79.2842L39.0902 89.4998L30.4003 83.1863L21.7104 89.4998L25.0298 79.2842L16.3398 72.9707H27.0811L30.4003 62.7551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.2011 62.7551L94.5203 72.9707H105.262L96.5716 79.2842L99.891 89.4998L91.2011 83.1863L82.5111 89.4998L85.8306 79.2842L77.1406 72.9707H87.8818L91.2011 62.7551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.003 62.7551L155.322 72.9707H166.063L157.373 79.2842L160.693 89.4998L152.003 83.1863L143.313 89.4998L146.632 79.2842L137.942 72.9707H148.684L152.003 62.7551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.801 62.7551L216.12 72.9707H226.862L218.172 79.2842L221.491 89.4998L212.801 83.1863L204.111 89.4998L207.431 79.2842L198.741 72.9707H209.482L212.801 62.7551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.603 62.7551L276.922 72.9707H287.663L278.973 79.2842L282.293 89.4998L273.603 83.1863L264.913 89.4998L268.232 79.2842L259.542 72.9707H270.284L273.603 62.7551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.405 62.7551L337.724 72.9707H348.465L339.775 79.2842L343.095 89.4998L334.405 83.1863L325.715 89.4998L329.034 79.2842L320.344 72.9707H331.085L334.405 62.7551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.8021 88.6015L64.1214 98.8171H74.8626L66.1727 105.131L69.4921 115.346L60.8021 109.033L52.1122 115.346L55.4316 105.131L46.7417 98.8171H57.4829L60.8021 88.6015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.6 88.6015L124.92 98.8171H135.661L126.971 105.131L130.29 115.346L121.6 109.033L112.911 115.346L116.23 105.131L107.54 98.8171H118.281L121.6 88.6015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.402 88.6015L185.721 98.8171H196.463L187.773 105.131L191.092 115.346L182.402 109.033L173.712 115.346L177.032 105.131L168.342 98.8171H179.083L182.402 88.6015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.204 88.6015L246.523 98.8171H257.264L248.575 105.131L251.894 115.346L243.204 109.033L234.514 115.346L237.833 105.131L229.144 98.8171H239.885L243.204 88.6015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.002 88.6015L307.321 98.8171H318.062L309.372 105.131L312.692 115.346L304.002 109.033L295.312 115.346L298.631 105.131L289.941 98.8171H300.683L304.002 88.6015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4003 114.448L33.7195 124.663H44.4607L35.7708 130.977L39.0902 141.193L30.4003 134.879L21.7104 141.193L25.0298 130.977L16.3398 124.663H27.0811L30.4003 114.448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.2011 114.448L94.5203 124.663H105.262L96.5716 130.977L99.891 141.193L91.2011 134.879L82.5111 141.193L85.8306 130.977L77.1406 124.663H87.8818L91.2011 114.448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.003 114.448L155.322 124.663H166.063L157.373 130.977L160.693 141.193L152.003 134.879L143.313 141.193L146.632 130.977L137.942 124.663H148.684L152.003 114.448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.801 114.448L216.12 124.663H226.862L218.172 130.977L221.491 141.193L212.801 134.879L204.111 141.193L207.431 130.977L198.741 124.663H209.482L212.801 114.448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.603 114.448L276.922 124.663H287.663L278.973 130.977L282.293 141.193L273.603 134.879L264.913 141.193L268.232 130.977L259.542 124.663H270.284L273.603 114.448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.405 114.448L337.724 124.663H348.465L339.775 130.977L343.095 141.193L334.405 134.879L325.715 141.193L329.034 130.977L320.344 124.663H331.085L334.405 114.448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.8021 140.294L64.1214 150.51H74.8626L66.1727 156.823L69.4921 167.039L60.8021 160.726L52.1122 167.039L55.4316 156.823L46.7417 150.51H57.4829L60.8021 140.294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.6 140.294L124.92 150.51H135.661L126.971 156.823L130.29 167.039L121.6 160.726L112.911 167.039L116.23 156.823L107.54 150.51H118.281L121.6 140.294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.402 140.294L185.721 150.51H196.463L187.773 156.823L191.092 167.039L182.402 160.726L173.712 167.039L177.032 156.823L168.342 150.51H179.083L182.402 140.294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.204 140.294L246.523 150.51H257.264L248.575 156.823L251.894 167.039L243.204 160.726L234.514 167.039L237.833 156.823L229.144 150.51H239.885L243.204 140.294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.002 140.294L307.321 150.51H318.062L309.372 156.823L312.692 167.039L304.002 160.726L295.312 167.039L298.631 156.823L289.941 150.51H300.683L304.002 140.294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4003 166.141L33.7195 176.356H44.4607L35.7708 182.67L39.0902 192.885L30.4003 186.572L21.7104 192.885L25.0298 182.67L16.3398 176.356H27.0811L30.4003 166.141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.2011 166.141L94.5203 176.356H105.262L96.5716 182.67L99.891 192.885L91.2011 186.572L82.5111 192.885L85.8306 182.67L77.1406 176.356H87.8818L91.2011 166.141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.003 166.141L155.322 176.356H166.063L157.373 182.67L160.693 192.885L152.003 186.572L143.313 192.885L146.632 182.67L137.942 176.356H148.684L152.003 166.141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.801 166.141L216.12 176.356H226.862L218.172 182.67L221.491 192.885L212.801 186.572L204.111 192.885L207.431 182.67L198.741 176.356H209.482L212.801 166.141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.603 166.141L276.922 176.356H287.663L278.973 182.67L282.293 192.885L273.603 186.572L264.913 192.885L268.232 182.67L259.542 176.356H270.284L273.603 166.141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.405 166.141L337.724 176.356H348.465L339.775 182.67L343.095 192.885L334.405 186.572L325.715 192.885L329.034 182.67L320.344 176.356H331.085L334.405 166.141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.8021 191.987L64.1214 202.203H74.8626L66.1727 208.516L69.4921 218.732L60.8021 212.418L52.1122 218.732L55.4316 208.516L46.7417 202.203H57.4829L60.8021 191.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.6 191.987L124.92 202.203H135.661L126.971 208.516L130.29 218.732L121.6 212.418L112.911 218.732L116.23 208.516L107.54 202.203H118.281L121.6 191.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.402 191.987L185.721 202.203H196.463L187.773 208.516L191.092 218.732L182.402 212.418L173.712 218.732L177.032 208.516L168.342 202.203H179.083L182.402 191.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.204 191.987L246.523 202.203H257.264L248.575 208.516L251.894 218.732L243.204 212.418L234.514 218.732L237.833 208.516L229.144 202.203H239.885L243.204 191.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.002 191.987L307.321 202.203H318.062L309.372 208.516L312.692 218.732L304.002 212.418L295.312 218.732L298.631 208.516L289.941 202.203H300.683L304.002 191.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4003 217.834L33.7195 228.049H44.4607L35.7708 234.363L39.0902 244.578L30.4003 238.265L21.7104 244.578L25.0298 234.363L16.3398 228.049H27.0811L30.4003 217.834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.2011 217.834L94.5203 228.049H105.262L96.5716 234.363L99.891 244.578L91.2011 238.265L82.5111 244.578L85.8306 234.363L77.1406 228.049H87.8818L91.2011 217.834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.003 217.834L155.322 228.049H166.063L157.373 234.363L160.693 244.578L152.003 238.265L143.313 244.578L146.632 234.363L137.942 228.049H148.684L152.003 217.834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.801 217.834L216.12 228.049H226.862L218.172 234.363L221.491 244.578L212.801 238.265L204.111 244.578L207.431 234.363L198.741 228.049H209.482L212.801 217.834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.603 217.834L276.922 228.049H287.663L278.973 234.363L282.293 244.578L273.603 238.265L264.913 244.578L268.232 234.363L259.542 228.049H270.284L273.603 217.834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.405 217.834L337.724 228.049H348.465L339.775 234.363L343.095 244.578L334.405 238.265L325.715 244.578L329.034 234.363L320.344 228.049H331.085L334.405 217.834Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66_570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 480,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.834f57b78a602e192f4dca128d5b6de1.svg";
export { ForwardRef as ReactComponent };